import { useTranslation } from "react-i18next";

const WhyRead = () => {
  const { t } = useTranslation();

  return (
    <article className="bg-white py-28">
      <div className="w-11/12 mx-auto text-center">
        <h1 className="text-[24px] md:text-[32px]  text-mainBlue font-bold mb-10">
          {t("whyRead?")}
        </h1>
        <p className="text-mainGray md:text-[20px] font-bold max-w-[900px] mx-auto">
          {t("successInLogistics")}
        </p>
      </div>
    </article>
  );
};

export default WhyRead;
